import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { State } from "../base/types";
import { MerchantBalance, getMerchantBalancesApi } from "./api";

type MerchantBalanceState = State<{
  balance: MerchantBalance | null;
}>;

export const getMerchantBalances = createAsyncThunk<MerchantBalance, string>(
  "merchantBalance/getBalances",
  async (userId, { rejectWithValue }) => {
    try {
      return await getMerchantBalancesApi(userId);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState: MerchantBalanceState = {
  balance: null,
  loading: false,
  error: null,
};

const merchantBalanceSlice = createSlice({
  name: "merchantBalance",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMerchantBalances.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMerchantBalances.fulfilled, (state, action) => {
        state.loading = false;
        state.balance = action.payload;
      })
      .addCase(getMerchantBalances.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default merchantBalanceSlice.reducer;
